export default (data) => {
    const locationData = {};
    data.forEach(row => {
        if(!locationData[row.id])
            locationData[row.id] = {
                cp: 0,
                wp: 0,
                id: row.id,
                location: row.location,
                name: row.name,
            };
        locationData[row.id].cp += row.cp;
        locationData[row.id].wp += row.wp;
    });
    const keys = Object.keys(locationData);
    keys.sort();
    return keys.map(key => locationData[key]);
}



// WEBPACK FOOTER //
// ./src/selectors/locations.js